import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import useMediaQuery from '@mui/material/useMediaQuery';
import DashboardCard from './DashboardCard';
import Link from 'next/link';
import AiCreditsBalance from './AiCreditsBalance';

const sortingOptions = [
  {
    label: 'Ai Blogger',
    link: '',
  },
  {
    label: 'Magic Maps',
    link: 'maps',
  },
  {
    label: 'Credits',
    link: 'credits',
  },
];

export default function AiBloggerTabs({
  activeTab,
  content,
  open,
  refetchCredits,
}) {
  const isMobileView = useMediaQuery('(max-width: 576px)');

  return (
    <>
      <AiCreditsBalance open={open} triggerRefetch={refetchCredits} />
      <div className="tw-container sm:tw-px-2 tw-m-auto pb-3 tw-max-w-4xl">
        <DashboardCard
          titleSize="h5"
          rawTitle={
            <div>
              <Tabs
                centered
                fullWidth
                variant={isMobileView ? 'fullWidth' : undefined}
                indicatorColor="primary"
                textColor="primary"
                value={activeTab}
              >
                {sortingOptions.map(topic => {
                  return (
                    <Link
                      href={`/dashboard/aiblogger${
                        topic.link ? `/${topic.link}` : ''
                      }?open=${open}`}
                      passHref
                      key={topic.label}
                    >
                      <Tab label={topic.label} key={topic.label} />
                    </Link>
                  );
                })}
              </Tabs>
            </div>
          }
          content={content}
        />
      </div>
    </>
  );
}
